/** Wersjonowanie i automatyczne aktualizacje panelu (klucze: appu.*). */
export const appuPl = {
  available: 'Dostępna nowa wersja panelu: v{version}',
  availableHint: 'Odśwież, kiedy Ci pasuje. Panel zrobi to sam, gdy wrócisz do karty po przerwie, a na ekranie nic nie będzie w toku.',
  refreshNow: 'Odśwież teraz',
  updated: 'Zaktualizowano do wersji v{version}',
  changelog: {
    title: 'Co nowego',
    description: 'Zmiany w kolejnych wersjach panelu, aplikacji i serwera.',
    ok: 'Rozumiem',
    empty: 'Brak wpisów do wyświetlenia.',
    latest: 'Najnowsza',
    kind: { added: 'Nowe', changed: 'Zmienione', fixed: 'Poprawione', note: 'Warto wiedzieć' },
  },
  about: {
    whatsNew: 'Co nowego',
    open: 'O aplikacji',
    title: 'O aplikacji',
    description: 'Wersje paneli i serwera, na których pracujesz.',
    panel: 'Panel',
    backend: 'Serwer (API)',
    check: 'Sprawdź aktualizacje',
    latest: 'Masz najnowszą wersję.',
    error: 'Nie udało się sprawdzić aktualizacji. Spróbuj ponownie.',
    auto: 'Panel sprawdza nowe wersje sam (po powrocie do karty i co 15 minut). Instaluje je, gdy wracasz do karty po przerwie, a na ekranie nic nie jest w toku — w innym razie czeka na Twoje kliknięcie.',
  },
};

export const appuEn: typeof appuPl = {
  available: 'A new panel version is available: v{version}',
  availableHint: 'Refresh whenever it suits you. The panel will do it by itself when you come back to the tab after a break and nothing is in progress on screen.',
  refreshNow: 'Refresh now',
  updated: 'Updated to version v{version}',
  changelog: {
    title: 'What\x27s new',
    description: 'Changes in successive versions of the panel, the app and the server.',
    ok: 'Got it',
    empty: 'Nothing to show.',
    latest: 'Latest',
    kind: { added: 'New', changed: 'Changed', fixed: 'Fixed', note: 'Good to know' },
  },
  about: {
    whatsNew: 'What\x27s new',
    open: 'About',
    title: 'About the app',
    description: 'Versions of the panel and the server you are working with.',
    panel: 'Panel',
    backend: 'Server (API)',
    check: 'Check for updates',
    latest: 'You are on the latest version.',
    error: 'Could not check for updates. Please try again.',
    auto: 'The panel checks for new versions by itself (when you return to the tab and every 15 minutes). It installs them when you come back to the tab after a break and nothing is in progress on screen — otherwise it waits for your click.',
  },
};
